import service from '@/utils/server';

const modName = '/bd/trackRejectApprover/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//详情
export const detailInfo = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};
//审批确认
export const submitApproval = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

//审批驳回
export const approvalRejected = data => {
  return service({
    url: modName + 'approvalRejected',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/reject/rejectApproval/api/index.js